import React, { Component } from 'react';
import {
  ComposedChart,  Line, Area, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
} from 'recharts';


export default class CompoChart extends Component {
  constructor(props) {
    super(props);
  } 
  //helper function to customize legend component
  renderLegend(value, entry) {
  	const { color } = entry;
    if(value === "Net"){
    	value =	value.replace("Net","Net Revenue")
    }
    return <span style={{ color }}>{value}</span>;
  }

  render() {
    const { data } = this.props; 
    console.log('Chart data:', data)
    return (
        <ComposedChart 
          width={1180}
          height={400} 
          data={data}
          margin={{top: 40, right: 50, bottom: 20, left: -15}}
        >
        <XAxis dataKey="date" angle={25} dx={15} dy={10} />
        <YAxis dataKey="Seats" yAxisId="left" />
        <YAxis dataKey="Net" label={{ value: "EGP", position: 'insideBottomRight', dy: 7, dx: 7}} yAxisId="right" orientation="right" />
        <Tooltip
         itemStyle={{ fontWeight: "bold" }}
         formatter={function(value, name) {
            if(name === "Net"){
              let Net = new Intl.NumberFormat('en').format(value)
              return ([ `${Net} EGP`, `${name.replace("Net", "Net Revenue")}`]);
            }
            if(name === "Bookings")
              return `${value}`;

            if(name === "Seats")
              return `${value}`;
          }}
        />
        <Legend 
          wrapperStyle={{lineHeight: '50px'}}
          formatter={this.renderLegend}
        />
        <CartesianGrid stroke='#e8e3e3'/>
        <Bar yAxisId="left"  dataKey='Bookings' barSize={20} fill='#FC9900' />
        <Bar yAxisId="left" dataKey='Seats' barSize={20} fill='#073E7E' />
        <Line yAxisId="right" dataKey='Net' type='monotone' stroke='#35B925' activeDot={{ r: 7 }}/>
      </ComposedChart>
    );
  }
}
